import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ModalService } from "./modal.service";

@Component({
    selector: "app-modal",
    templateUrl: "./modal.component.html",
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {
  @ViewChild('modal') modal: ElementRef;
  modalData = {};

  constructor(private readonly modalService: ModalService) {}

  ngOnInit() {
    this.modalService.modalOpen.subscribe(res => {
      if (res) { this.open(res); }
    })
  }

  open(data) {
    this.modal.nativeElement.style.display = 'flex';
    this.modalData = data;
  }

  close() {
    this.modal.nativeElement.style.display = 'none';
    this.modalService.modalOpen.next(false);
    this.modalService.closeEvent.next(true);
  }

  confirm() {
    this.close();
    this.modalService.modalData.next(this.modalData);
    this.modalService.confirmEvent.next(true);
  }
}
